import React from "react"
import ReactDOM from "react-dom"
import { App } from "./App"
import { ThemeProvider } from "@material-ui/core/styles"
import "./styles.scss"
import "fontsource-roboto"
import { defaultTheme } from "./defaultTheme"

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={defaultTheme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root")
)
